<template>
	<div class="row my-4">
		<div class="input-group">
			<div class="form-outline">
				<input class="my-form-control" v-model="queryData.searchKey" @keyup.enter="searchImage" />
			</div>
			<button type="button" class="btn btn-primary" @click="searchImage">
				<i class="fas fa-search"></i>
			</button>
		</div>
	</div>
	<div class="row row-cols-1 row-cols-md-5 g-4">
		<div class="col" v-for="item in images" :key="item.id" :item="item">
			<div class="card h-100">
				<div class="zoomImage" :style="'background-image:url(' + item.url + ')'" @click="clickImage(item)">
				</div>
				
				<div class="card-body">
					<div class="card-title" style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
						{{ item.userTitle }}</div>
				</div>
				<!-- <div v-if="loading" class="mask" style="background-color: rgba(0, 0, 0, 0.6)">
					<div class="spinner-border text-secondary m-5" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="row my-4">
		<pagination class="d-flex justify-content-end" :total="queryData.total" :pageSize="queryData.size"
			:showSizeChanger="false" @change="pageChange" />
	</div>
</template>

<script>
	import {
		Pagination
	} from "ant-design-vue";
	export default {
		components: {
			Pagination,
		},
		data() {
			return {
				loading: false,
				queryData: {
					searchKey: "",
					total: 1,
					page: 1,
					size: 15,
					totalPage: 1,
				},
				images: [],
			};
		},
		methods: {
			getImages() {
				this.loading = true;
				let s = this.queryData.searchKey;
				let skip = (this.queryData.page - 1) * this.queryData.size;

				var cql = "select count(*),* from Pic ";
				if (s != "") {
					cql += `where userTitle like '%${s}%' or tags like '%${s}%' `;
				}
				cql += `limit ${skip}, ${this.queryData.size} order by -id`;
				this.$AV.Query.doCloudQuery(cql).then((res) => {
					this.images = [];
					res.results.forEach((img) => {
						this.images.push(img.attributes);
					});
					this.queryData.total = res.count;
					this.loading = false;
				});
			},
			clickImage(img) {
				if (img.status == -1) {
					this.$viewerApi({
						images: [img.url],
					});
				} else {
					window.open("https://www.raw.cn/Detailpic?id=" + img.id, "_blank");
				}
			},
			pageChange(page) {
				this.queryData.page = page;
				this.getImages();
				window.scrollTo(0, 0);
			},
			searchImage() {
				this.queryData.page = 1;
				
				this.getImages();
			},
		},
		// computed: {
		//     isLogin() {
		//         return this.$store.state.UserStore.isLogin;
		//     }
		// },
		created() {
			// this.queryData.eventId = -1;
			// if (this.$route.query.eventId) {
			// 	this.queryData.eventId = this.$route.query.eventId;
			// }

			if(this.images.length == 0) {
				this.getImages();
			}
		}
	};
</script>

<style scoped>
	/* .active-green input[type="text"]:focus:not([readonly]) {
	border-bottom: 1px solid lightgreen;
	box-shadow: 0 1px 0 0 lightgreen;
} */
	.zoomImage {
		width: 100%;
		height: 0;
		padding-bottom: 60%;
		overflow: hidden;
		background-position: center center;
		background-repeat: no-repeat;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		background-size: cover;
	}

	.my-form-control {
		/* pointer-events: none; */
		min-height: auto;
		padding: 0.33em 0.75em;
		border: 1px solid #bdbdbd;
		box-sizing: border-box;
		border-radius: 0.3;
		background: transparent;
		transition: all 0.2s linear;
	}
</style>